import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-about',
  standalone: true,
  imports: [CommonModule],
  template: `
    <section class="min-h-screen pt-24 pb-16">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <!-- Header -->
        <div class="fade-in-left text-center mb-12 lg:mb-16">
          <div class="inline-flex items-center gap-2 bg-primary/10 rounded-full px-4 py-2 mb-4">
            <svg class="w-4 h-4 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>
            <span class="text-sm font-medium text-primary">درباره ما</span>
          </div>
          <h2 class="text-3xl sm:text-4xl lg:text-5xl font-black mb-4">
            باشگاه <span class="text-primary">پارس فیتنس</span>
          </h2>
          <p class="text-muted-foreground max-w-2xl mx-auto text-base lg:text-lg">
            بیش از ۱۵ سال تجربه در ارائه بهترین خدمات ورزشی با استانداردهای بین‌المللی
          </p>
        </div>

        <!-- Main Content -->
        <div class="grid lg:grid-cols-2 gap-8 lg:gap-12 mb-16">
          <div class="fade-in-left relative rounded-2xl overflow-hidden" style="animation-delay: 0.1s">
            <img src="https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800&q=80" alt="باشگاه" class="w-full h-[350px] lg:h-[450px] object-cover"/>
            <div class="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent"></div>
            <div class="absolute bottom-6 right-6 left-6">
              <div class="flex items-center gap-4 bg-background/80 backdrop-blur-sm rounded-xl p-4">
                <div class="text-center"><div class="text-2xl font-black text-primary">۱۵+</div><div class="text-xs text-muted-foreground">سال تجربه</div></div>
                <div class="w-px h-10 bg-border"></div>
                <div class="text-center"><div class="text-2xl font-black text-primary">۵۰+</div><div class="text-xs text-muted-foreground">مربی حرفه‌ای</div></div>
                <div class="w-px h-10 bg-border"></div>
                <div class="text-center"><div class="text-2xl font-black text-primary">۲۰+</div><div class="text-xs text-muted-foreground">دوره آموزشی</div></div>
              </div>
            </div>
          </div>

          <div class="fade-in-left space-y-6" style="animation-delay: 0.2s">
            <h3 class="text-2xl lg:text-3xl font-bold">ماموریت ما: سلامت و تناسب اندام برای همه</h3>
            <p class="text-muted-foreground leading-7">باشگاه ورزشی پارس فیتنس از سال ۱۳۸۸ فعالیت خود را آغاز کرده و با هدف ارائه خدمات ورزشی حرفه‌ای به همه اقشار جامعه، توانسته است به یکی از معتبرترین باشگاه‌های ورزشی کشور تبدیل شود.</p>
            <p class="text-muted-foreground leading-7">تیم ما متشکل از مربیان با تجربه و دارای مدارک بین‌المللی است که با طراحی برنامه‌های تمرینی اختصاصی، شما را در رسیدن به اهدافتان همراهی می‌کنند.</p>
            <div class="grid grid-cols-2 gap-3">
              <div *ngFor="let item of checkItems" class="flex items-center gap-2">
                <svg class="w-4 h-4 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>
                <span class="text-sm">{{ item }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Vision/Mission Cards -->
        <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16 stagger-children">
          <div *ngFor="let card of visionCards" class="bg-card border border-border rounded-xl p-6 hover:border-primary/30 transition-colors sports-card">
            <div class="w-14 h-14 rounded-2xl flex items-center justify-center mb-4" [ngClass]="card.bg">
              <span [innerHTML]="card.iconHtml"></span>
            </div>
            <h3 class="text-xl font-bold mb-3">{{ card.title }}</h3>
            <p class="text-muted-foreground text-sm leading-6">{{ card.desc }}</p>
          </div>
        </div>

        <!-- Achievements -->
        <div class="fade-in-left overflow-hidden rounded-xl">
          <div class="gradient-border p-px rounded-xl">
            <div class="bg-background rounded-xl p-6 lg:p-8">
              <div class="flex items-center gap-2 mb-6">
                <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/></svg>
                <h3 class="text-xl font-bold">افتخارات برجسته</h3>
              </div>
              <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                <div *ngFor="let ach of achievements" class="text-center">
                  <div class="text-3xl mb-2">{{ ach.icon }}</div>
                  <div class="text-3xl font-black text-primary">{{ ach.value }}</div>
                  <div class="text-sm text-muted-foreground mt-1">{{ ach.label }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  `,
  styles: [':host { display: block; }']
})
export class AboutComponent {
  checkItems = [
    'مربیان دارای مدرک بین‌المللی',
    'تجهیزات پیشرفته ایتالیایی',
    'محیطی امن و بهداشتی',
    'پارکینگ رایگان'
  ];

  visionCards = [
    {
      title: 'چشم‌انداز',
      desc: 'تبدیل شدن به بهترین مرکز ورزشی خاورمیانه با استانداردهای جهانی و ارائه خدمات نوین ورزشی و سلامتی به بیش از ۱۰۰,۰۰۰ عضو تا سال ۱۴۱۰.',
      bg: 'bg-red-500/10',
      iconHtml: '<svg class="w-7 h-7 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>'
    },
    {
      title: 'ماموریت',
      desc: 'ایجاد یک جامعه ورزشی سالم و فعال از طریق ارائه آموزش‌های حرفه‌ای، تجهیزات مدرن و محیطی انگیزشی برای تمامی سنین و سطوح آمادگی جسمانی.',
      bg: 'bg-orange-500/10',
      iconHtml: '<svg class="w-7 h-7 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
    },
    {
      title: 'ارزش‌های ما',
      desc: 'تعهد به کیفیت، احترام به مشتری، نوآوری مداوم، کار تیمی، و مسئولیت اجتماعی. ما به رشد و پیشرفت هر عضو اهمیت می‌دهیم.',
      bg: 'bg-amber-500/10',
      iconHtml: '<svg class="w-7 h-7 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>'
    },
  ];

  achievements = [
    { icon: '🥇', value: '۳', label: 'بار قهرمانی کشور' },
    { icon: '🏆', value: '۱۲', label: 'مدال طلای مسابقات' },
    { icon: '⭐', value: '۵', label: 'ستاره باشگاه' },
    { icon: '🎖️', value: '۲۰+', label: 'جایزه کیفیت' },
  ];
}
